// Centralized API Configuration
// All API base URLs are managed from here for both development and production environments

const API_CONFIG = {
  development: {
    //  v1: 'http://localhost:3002/v1',
    //  v2: 'http://localhost:3002/v2',
    v1: 'https://api.littlebookcompany.net/v1',
    v2: 'https://api.littlebookcompany.net/v2',
  },
  production: {
    v1: 'https://api.littlebookcompany.net/v1',
    v2: 'https://api.littlebookcompany.net/v2',
  }
};

// Get current environment
const isProduction = process.env.NODE_ENV === 'production';
const environment = isProduction ? 'production' : 'development';

// Export base URLs
export const API_BASE_URL_V1 = API_CONFIG[environment].v1;
export const API_BASE_URL_V2 = API_CONFIG[environment].v2;

// Export full config for reference
export default API_CONFIG;
